import { Component, Inject, Input, OnInit } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import { SharedOrderService } from '../../../../core/services/shared-order.service';
import { Restaurant } from '../../../../core/models/restaurant.model';
import { CreateSharedOrder, SharedOrderResponse } from '../../../../core/models/shared-order.model';
import { environment } from '../../../../../environments/environment';
import { PaymentStore } from '../../../../core/stores/payment.store';
import {UrlParam} from '../../../../core/enums/group-param.enum';
import {CartStore} from '../../../../core/stores/cart.store';
import {SharedOrderText} from '../../../../core/enums/shared-order.enum';

@Component({
  selector: 'app-shared-orders-modal',
  templateUrl: './shared-orders-modal.component.html',
  styleUrls: ['./shared-orders-modal.component.scss'],
})
export class SharedOrdersModalComponent implements OnInit {
  public restaurant: Restaurant =  new Restaurant();
  public sharedOrder: boolean;
  public shareQrLink: string;
  public sharedCreated: boolean;
  public isLoading: boolean;
  public sharedOrderText = SharedOrderText;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    private sharedOrderService: SharedOrderService,
    private paymentStore: PaymentStore,
    private dialogRef: MatDialogRef<SharedOrdersModalComponent>,
    private cartStore: CartStore
  ) { }

  ngOnInit() {
    this.initData();
    this.getTabs();
  }

  public copySharedUrl(): void {
    const textarea = document.createElement('textarea');
    textarea.value = this.shareQrLink;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
  }

  public createSharedOrder(): void {
    if (this.sharedCreated) {
      this.dialog.closeAll();
      return;
    }
    this.isLoading = true;
    const sharedBody = new CreateSharedOrder();
    if (this.restaurant.enableSharedOrderSingleOrderReceivedSms) {
      sharedBody.phone_number = this.paymentStore.phoneNumber;
    }
    this.sharedOrderService.createSharedOrder(this.restaurant.locationId, sharedBody)
      .subscribe((sharedOrder: SharedOrderResponse) => {
        this.shareQrLink = environment.apiUrl + `shared-orders/${sharedOrder.sharedOrderId}`;
        sessionStorage.setItem(UrlParam.sharedOwnerId, sharedOrder.sharedOrderId);
        this.sharedOrderService.sharedOwnerId$ = sharedOrder.sharedOrderId;
        this.sharedCreated = true;
        this.isLoading = false;
      }, () => {
        this.isLoading = false;
      });
  }
  private getTabs(): void {
    this.cartStore.tab$.subscribe(tab => {
      if (tab) {
        this.dialog.closeAll();
      }
    });
  }

  private initData(): void {
    if (this.data && this.data.restaurant) {
      this.restaurant = this.data.restaurant;
    }
    if (this.data && this.data.isView) {
      this.sharedOrder = true;
      this.sharedCreated = true;
      this.shareQrLink = environment.apiUrl + `shared-orders/${this.sharedOrderService.sharedOwnerId$}`;
    }
  }
}
